const dateTimeStr = new Date()?.toISOString();

export const baseUCGet = ({  userId = '', }) => {
    return {
        created: dateTimeStr,
        userId: userId,
    };
}